var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { StickyHandler } from '../../table/src';
export var stickyVisibleClass = 'awsui-cards-sticky';
export var stickyLeavingClass = 'awsui-cards-sticky-leaving';
var CardsStickyHandler = /** @class */ (function (_super) {
    __extends(CardsStickyHandler, _super);
    function CardsStickyHandler(node, verticalOffset) {
        var _this = _super.call(this, node, verticalOffset) || this;
        _this.stickyVisibleClass = stickyVisibleClass;
        _this.stickyLeavingClass = stickyLeavingClass;
        return _this;
    }
    CardsStickyHandler.prototype.handleContainerChange = function () {
        this.updateLayout();
    };
    CardsStickyHandler.prototype.getStickyNode = function () {
        return this.node.querySelector('.awsui-cards-regions-container');
    };
    CardsStickyHandler.prototype.getRootElement = function () {
        return this.node.querySelector('.awsui-cards-inner');
    };
    CardsStickyHandler.prototype.getHeaderStrut = function () {
        return this.node.querySelector('.awsui-cards-heading-strut');
    };
    CardsStickyHandler.prototype.getStrutOriginal = function () {
        return this.getStickyNode();
    };
    CardsStickyHandler.prototype.getItemsContainer = function () {
        return this.node.querySelector('.awsui-cards-container');
    };
    return CardsStickyHandler;
}(StickyHandler));
export default CardsStickyHandler;
//# sourceMappingURL=cards-sticky-handler.js.map